import { el } from 'redom';

import SingleSelectNative from 'generics/components/single-select/native';

import { getIndicesByPropertyValues, getPropertyValues, filterByPropertyValueBasic } from 'utilities/collection';

import './index.scss';

class FieldSelector {

  constructor(configuration) {

    this.editor = configuration.editor;
    this.node = configuration.node;
    this.activeNodePath = configuration.activeNodePath;
    this.onSelect = configuration.onSelect;
    this.onDeselect = configuration.onDeselect;
    this.displayedColumnIds = getPropertyValues(filterByPropertyValueBasic(this.node.properties.columns || [], 'displayed', true), '_id');

    this.fieldsSelectInput = new SingleSelectNative(this.buildFieldsSelectInputOptions());

    this.el = el('.data-collection-field-selector-main', [
      el('label.side-value-control-label.field-label', 'Database fields to display'),
      this.fieldsSelectInput
    ]);

  }

  handleSelectionChange({ values }) {

    if (values.length === 0) {
      this.fieldsSelectInput.setValue(this.displayedColumnIds[0]);
      const unselectedColumnIds = this.displayedColumnIds.splice(1, this.displayedColumnIds.length);
      this.onDeselect(unselectedColumnIds);
      return;
    }

    if (this.displayedColumnIds.length > values.length) {
      const unselectedColumnIds = [];
      for (let columnId of this.displayedColumnIds) {
        if (values.indexOf(columnId) === -1) {
          unselectedColumnIds.push(columnId);
        }
      }
      this.onDeselect(unselectedColumnIds);
    } else {
      const selectedColumnIds = [];
      for (let columnId of values) {
        if (this.displayedColumnIds.indexOf(columnId) === -1) {
          selectedColumnIds.push(columnId);
        }
      }
      this.onSelect(selectedColumnIds);
    }

  }

  buildFieldsSelectInputOptions() {

    const options = {
      multiSelect: true,
      onChange: this.handleSelectionChange.bind(this),
      placeholder: 'Select fields',
      labelFieldName: 'name',
      valueFieldName: '_id',
      options: this.node.properties.columns || [],
      selectedOptionIndices: getIndicesByPropertyValues(this.node.properties.columns || [], 'displayed', [true])
    };

    return options;

  }

  update(configuration) {

    this.editor = configuration.editor;
    this.node = configuration.node;
    this.activeNodePath = configuration.activeNodePath;
    this.displayedColumnIds = getPropertyValues(filterByPropertyValueBasic(this.node.properties.columns || [], 'displayed', true), '_id');

  }

}

export default FieldSelector;